<template>
  <div class="materia-container">
    <CardIeaAppMain colorCard="transparent" title="" class="premium-wrapper">
      <v-col cols="12" class="pa-0">
        
        <!-- Hero Header -->
        <div class="hero-header glass-panel mb-4 py-3 px-6 mx-4 mt-4">
          <div class="d-flex align-center justify-space-between w-100">
            <div class="d-flex align-center">
              <v-btn icon dark color="primary" class="mr-4 glass-btn" @click="$router.go(-1)">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <div>
                <h1 class="text-h5 font-weight-bold primary-text mb-0">Inscripción a Materias</h1>
                <p class="text-caption grey--text text--darken-1 mb-0">Gestión Académica</p>
              </div>
            </div>
            <v-icon size="48" color="primary" class="opacity-30">mdi-book-education-outline</v-icon>
          </div>
        </div>

        <!-- Main Content -->
        <v-card class="glass-card rounded-xl overflow-hidden mx-4 mb-4" elevation="10">
          <div class="pa-6 content-area bg-light">
            
            <v-alert v-if="existeContactoBce != false" prominent outlined type="info" class="rounded-xl glass-card border-none mb-6">
              <strong>Reunión Programada:</strong> Tiene una reunión para inscripción a materias el día {{ contactoBce.fecha_atencion }} a las {{ contactoBce.hora_atencion }} con {{ ((contactoBce.usuario) ? contactoBce.usuario.usu_nombre : '') }}.
            </v-alert>

            <v-alert v-else-if="user.excedente" prominent outlined type="warning" class="rounded-xl glass-card border-none mb-6">
              <strong>Fuera de Término:</strong> No es posible inscribirse a cursar materias porque estamos fuera del período de inscripción.
            </v-alert>

            <div v-else>
              <div v-if="materias.cantidad == 0" class="text-center pa-10 bg-light-gradient rounded-xl mt-4">
                <v-icon size="64" color="grey lighten-2">mdi-book-off-outline</v-icon>
                <h3 class="text-h6 grey--text text--darken-1 mt-4">Sin inscripciones</h3>
                <p class="text-body-2 grey--text">En este momento no hay inscripciones abiertas a materias.</p>
              </div>

              <div v-for="(examenMesa, examenMesaKey) in materias.data" :key="examenMesaKey" class="mb-8">
                <div class="d-flex align-center justify-space-between mb-4">
                  <h2 class="text-h6 font-weight-bold primary-text mb-0">
                    <v-icon color="primary" class="mr-2">mdi-school</v-icon>
                    {{ examenMesa.curso.Feriado }}
                  </h2>
                  <v-chip small color="primary lighten-5" text-color="primary darken-2" class="font-weight-bold">
                    Disponibles: {{ examenMesa.cantidad }}
                  </v-chip>
                </div>

                <v-card class="rounded-xl border-light overflow-hidden" elevation="0">
                  <v-list class="pa-0 bg-transparent">
                    <template v-for="(planDeEstudioData, planDeEstudioDataKey) in examenMesa.curso.plan_de_estudio_v2">
                      <v-list-item :key="planDeEstudioDataKey" class="py-3 px-4 border-bottom hover-row">
                        <v-list-item-content>
                          <v-list-item-title class="font-weight-bold primary-text text-wrap">
                            {{ planDeEstudioData.Materia }}
                          </v-list-item-title>
                        </v-list-item-content>
                        
                        <v-list-item-action class="ml-4 flex-row align-center justify-end" style="min-width: 140px;">
                          <!-- TIPO 0 -->
                          <div v-if="planDeEstudioData.tipo == 0">
                            <v-chip small color="grey lighten-3" text-color="grey darken-1" class="font-weight-bold">
                              <v-icon left small>mdi-calendar-remove</v-icon> Sin Mesa Aún
                            </v-chip>
                          </div>

                          <!-- TIPO 1 -->
                          <div v-if="planDeEstudioData.tipo == 1">
                            <v-btn
                              v-if="planDeEstudioData.Nota == null && planDeEstudioData.inscrita == false && planDeEstudioData.tipoNota == null"
                              @click="inscripcionMesaMateria(planDeEstudioData.IDStB, examenMesa.id)"
                              rounded depressed small color="primary" class="shadow-premium px-4 font-weight-bold"
                            >
                              Inscribir
                            </v-btn>
                            <div v-else>
                              <v-chip v-if="planDeEstudioData.inscrita == true && planDeEstudioData.Nota < 4" small color="error lighten-5" text-color="error darken-1" class="font-weight-bold">
                                Materia Inscripta
                              </v-chip>
                              <v-chip v-else-if="planDeEstudioData.tipoNota == 'tentativa'" small color="warning lighten-5" text-color="warning darken-2" class="font-weight-bold">
                                Equivalencia Tentativa
                              </v-chip>
                              <v-chip v-else small color="success lighten-5" text-color="success darken-2" class="font-weight-bold">
                                <v-icon left small>mdi-check</v-icon> Materia Aprobada
                              </v-chip>
                            </div>
                          </div>

                          <!-- TIPO 2 -->
                          <div v-if="planDeEstudioData.tipo == 2" class="d-flex align-center">
                            <v-chip small color="info lighten-5" text-color="info darken-2" class="font-weight-bold mr-2">
                              <v-icon left small>mdi-clock-outline</v-icon> Esperando Confirmación
                            </v-chip>
                            <v-btn icon small color="error" @click="cancelarInscripcionMesaMateria(planDeEstudioData.materia_inscipcion_alumno[0].id_validacion)" title="Cancelar">
                              <v-icon>mdi-close-circle</v-icon>
                            </v-btn>
                          </div>

                          <!-- TIPO 3 -->
                          <div v-if="planDeEstudioData.tipo == 3">
                            <v-chip small color="success lighten-5" text-color="success darken-2" class="font-weight-bold">
                              Inscripto
                            </v-chip>
                          </div>

                          <!-- TIPO 5 -->
                          <div v-if="planDeEstudioData.tipo == 5" class="d-flex align-center">
                            <v-chip small color="info lighten-5" text-color="info darken-2" class="font-weight-bold mr-2">
                              <v-icon left small>mdi-check-circle-outline</v-icon> Inscripto
                            </v-chip>
                            <v-btn icon small color="error" @click="cancelarInscripcionMesaMateria(planDeEstudioData.materia_inscipcion_alumno[0].id_validacion)" title="Cancelar">
                              <v-icon>mdi-close-circle</v-icon>
                            </v-btn>
                          </div>

                          <!-- TIPO 4 -->
                          <div v-if="planDeEstudioData.tipo == 4">
                            <v-chip small color="error lighten-5" text-color="error darken-1" class="font-weight-bold">
                              Rechazado
                            </v-chip>
                          </div>
                        </v-list-item-action>
                      </v-list-item>
                      <v-divider :key="'div-'+planDeEstudioDataKey" v-if="planDeEstudioDataKey < examenMesa.curso.plan_de_estudio_v2.length - 1"></v-divider>
                    </template>
                  </v-list>
                </v-card>
              </div>
            </div>
          </div>
        </v-card>
      </v-col>
    </CardIeaAppMain>
  </div>
</template>

<script>
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
  name: "Nota",
  components: {
    CardIeaAppMain,
  },

  data: () => ({
    title: "Tus inscripciones a materias",
    materias: [],
    existeContactoBce: false,
    contactoBce: null
  }),
  methods: {
    async inscripcionMesaMateria(examen, mesa) {
      await this.$API
        .post({
          url: "materia/mesas-inscripcion",
          data: {
            materia_id: examen,
            examenMesa_id: mesa,
          },
        })
        .then(() => {
          this.mesaDeMateria();
        });
    },
    async cancelarInscripcionMesaMateria(id) {
      await this.$API
        .post({
          url: "materia/cancelar-inscripcion",
          data: {
            id: id,
          },
        })
        .then(() => {
          this.mesaDeMateria();
        });
    },
    mesaDeMateria() {
      this.$API
        .get({
          url: "materia/mesas",
          data: {},
        })
        .then((res) => {
          this.materias = res;
        });
    },
    async obtenerContacto() {
      await this.$API
        .post({
          url: "contacto-bce/obtener-contacto",
          data: {
            alumno: this.user.IDStB,
          },
        })
        .then((res) => {
          this.existeContactoBce = res.existe
          this.contactoBce = res.contacto
        })
    }
  },

  mounted() {
    if (
      this.$store.getters.user.borrado == 1 ||
      this.$store.getters.user.alumno_mora == true ||
      this.$store.getters.user.excedente
    ) {
      this.$router.push({
        name: "Home",
      });
    }

    this.mesaDeMateria();
    this.obtenerContacto()
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
};
</script>

<style scoped>
/* Glassmorphism Classes (Premium UI) */
.materia-container {
  background: transparent !important;
  min-height: calc(100vh - 120px);
}

.glass-panel {
  background: rgba(255, 255, 255, 0.7) !important;
  backdrop-filter: blur(16px) !important;
  -webkit-backdrop-filter: blur(16px) !important;
  border: 1px solid rgba(255, 255, 255, 0.5) !important;
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.05) !important;
  border-radius: 20px;
  padding: 24px;
}

.glass-card {
  background: rgba(255, 255, 255, 0.85) !important;
  backdrop-filter: blur(16px) !important;
  -webkit-backdrop-filter: blur(16px) !important;
  border: 1px solid rgba(255, 255, 255, 0.4) !important;
}

.glass-btn {
  background: rgba(25, 118, 210, 0.1) !important;
  backdrop-filter: blur(4px) !important;
  box-shadow: none !important;
  transition: all 0.3s ease;
}
.glass-btn:hover {
  background: rgba(25, 118, 210, 0.2) !important;
  transform: translateY(-2px);
}

.bg-light { background-color: #f8fafc !important; }
.bg-light-gradient { background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%); }
.bg-transparent { background-color: transparent !important; }

.border-light { border: 1px solid rgba(0, 0, 0, 0.05) !important; }
.border-bottom { border-bottom: 1px solid rgba(0, 0, 0, 0.05); }

.hover-row {
  transition: background-color 0.2s ease;
}
.hover-row:hover {
  background-color: #f1f5f9 !important;
}

.shadow-premium {
  box-shadow: 0 8px 20px -6px rgba(25, 118, 210, 0.4) !important;
}

.primary-text { color: #1e293b; }
.opacity-30 { opacity: 0.3; }
</style>
